import React from "react";
import IFM from "../../../../assets/images/ifm.svg";

const FormWrapper = ({ name, logo }) => {
  // if logo is passed, use it; otherwise fallback to IFM
  const logoToUse = logo || IFM;

  return (
    <div>
      <img src={logoToUse} alt="header-logo" style={{ width: "100%", maxWidth: "200px" }} />
      <span
        style={{
          display: "block",
          marginTop: "30px",
          marginBottom: "30px",
          textAlign: "center",
          fontWeight: "bold",
          color: "#335CAD",
        }}
      >
        {name}
      </span>
    </div>
  );
};

export default FormWrapper;
